import React, { useEffect, useState } from 'react'
import './CreateRequestModal.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpdeskApiCall from 'HelpdeskApiCall';
import config from 'config';
import { toast } from 'react-toastify';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import microPhoneRequest from 'HELPDESK/CommonResources/images/microPhone.svg';

// BOOTSTRAP MODAL AT CENTER  HAVING HEADER Background 0465ac
const CreateRequestModal = ({ open, onClose = (status, { }) => { } }) => {
    const [isChecked, setISChecked] = useState(false);
    const [scheduledTime, setScheduledTime] = useState('');
    const [moduleList, setModuleList] = useState({});
    const [moduleListFetching, setModuleListFetching] = useState(false);
    const [moduleId, setModuleId] = useState('');
    const [moduleIdWarning, setModuleIdWarning] = useState('');
    const [isRaisingRequest, setIsRaisingRequest] = useState(false);

    useEffect(() => {
        apiCallToSubscriptionModuleList();
    }, [])


    // API CALL METHOD TO GET MODULE LIST
    const apiCallToSubscriptionModuleList = async () => {
        setModuleListFetching(true)

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMCurrentSubscriptionWiseModuleList',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToSubscriptionModuleList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                setModuleList(apiResult);
                setModuleListFetching(false);
            } else {
                setModuleList({});
                setModuleListFetching(false);
            }
        }
    }

    // API CALL METHOD TO GET MODULE LIST
    const apiCallToRaiseRequest = async () => {
        setIsRaisingRequest(true);

        let request = {
            module_id: moduleId,
            iid: config.institute_id,
            added_by: config.faculty_id,
            request_datetime: isChecked ? scheduledTime : '',

        }

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'pmTool_addCallBackRequest',
            request,
            '/api/projectManagement/callBackRequest/callBackClient.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToRaiseRequest();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status == 'success') {
                    // onClose();
                    setIsRaisingRequest(false);
             
                    setISChecked(false);
                    setScheduledTime('');
                    onClose("success", { moduleId: moduleId });
                           toast.success(jsonResponse.APIResult.message + jsonResponse.APIResult?.insert_id)
                    setModuleId('');
                    setModuleIdWarning('');

                }
                else {
                    setIsRaisingRequest(false);
                    toast.warning(jsonResponse.APIResult.message);

                }



            } else {
                setModuleList({});
                setIsRaisingRequest(false);
            }
        }
    }


    const validateRequest = () => {
        let validate = true;
        if (moduleId == '') {
            validate = false;
            toast.warning('Please select module');
            setModuleIdWarning('Please select module');
        }
        if (isChecked && scheduledTime == '') {
            validate = false;
            toast.warning('Please select scheduled time');
        }

        if (validate) {
            apiCallToRaiseRequest();
        }
    }


    if (!open) return null;

    return (
        <div className={open ? "modal fade show" : "modal fade"} id="modalContainer" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="addRequestCallHeader" >
                        <p className='poppins-font' style={{ paddingLeft: '10px', fontSize: '18px' }}>Add Call Request</p>
                        <FontAwesomeIcon icon={["fas", "times"]} onClick={()=>onClose("fail",{})} style={{ cursor: "pointer" }} />
                    </div>
                    <div className="modal-body">
                        <div className='add-request-container'>
                            <div className='custom-form-group'>
                                <label className="vm_custom_body14"
                                    style={{ color: '#000000' }} htmlFor="instituteType">Select Module <span style={{ color: 'red' }}>*</span></label>
                                <div className="input-container-field">
                                    <select
                                        className="form-control requestFilterSelect"
                                        value={moduleId}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setModuleId(value);

                                            if (!value) {
                                                setModuleIdWarning("Select Module");
                                            } else {
                                                setModuleIdWarning("");
                                            }
                                        }}
                                    >
                                        <option value="">Select Module</option>

                                        {/* Loading state */}
                                        {moduleListFetching && (
                                            <option disabled>Loading modules...</option>
                                        )}



                                        {/* Data */}
                                        {!moduleListFetching &&
                                            Object.keys(moduleList).length > 0 && Object.values(moduleList).map((module) => (
                                                <option key={module.moduleId} value={module.moduleId}>
                                                    {module.module_name}
                                                </option>
                                            ))}
                                    </select>

                                    <span className='vm_custom_body3' style={{ color: 'red', fontSize: '12px' }}>{moduleIdWarning}</span>
                                </div>
                            </div>
                            <div className='d-flex flex-row align-items-center g-4' style={{ gap: '16px' }}>
                                <span className='vm_custom_body10' style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <input
                                        onChange={() => { setISChecked(false); setScheduledTime(''); }}
                                        checked={!isChecked}
                                        type='checkbox'
                                        style={{ cursor: 'pointer',height:'16px',width:'16px' }}
                                    />
                                    Now
                                </span>
                                <span className='vm_custom_body10' style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <input onChange={() => setISChecked((prev) => !prev)} style={{ cursor: 'pointer',height:'16px',width:'16px' }} checked={isChecked} type='checkbox' />Schedule Later
                                </span>

                            </div>

                            {/* IS LATER ACTIVATE THEN ONLY SHOW  */}
                            {isChecked && (
                                <div className='d-flex flex-column'>
                                    <label className="vm_custom_body14"
                                        style={{ color: '#000000' }} htmlFor="Schedule">Schedule Time<span style={{ color: 'red' }}>{isChecked ? ' *' : ''} </span></label>

                                    {/* <span className='vm_custom_body10'>Schedule Time</span> */}
                                    <div className="input-container-field">
                                        <input type='datetime-local' className='form-control requestFilterSelect' value={scheduledTime} onChange={(e) => setScheduledTime(e.target.value)} />
                                    </div>
                                </div>
                            )}


                        </div>
                        {/* div */}
                        <div className='d-flex flex-row justify-content-end g-3' style={{ gap: '12px', marginTop: '24px' }}>
                            <button disabled={isRaisingRequest} onClick={()=>onClose("fail",{})} className='executive-custom-button executive-cancel-btn'  style={{}}>
                                {isRaisingRequest ? <ButtonLoader /> :

                                    <span className='vm_custom_body4'>Cancel</span>}

                            </button>
                            <button disabled={isRaisingRequest} onClick={validateRequest} className='callback-custom-button executive-assign-btn' style={{}}>
                                {isRaisingRequest ? <ButtonLoader /> :
                                    <><img src={microPhoneRequest} alt='microPhoneRequest'
                                        style={{ marginRight: '6px' }}
                                    />
                                        <span className='vm_custom_body4'>Raise Request</span></>}

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div >)
}
export default CreateRequestModal;